import { StoricoCambioPrezzoBene } from "../../models/StoricoCambioPrezzoBeneModel"
import { Timeline, TimelineItem, TimelineOppositeContent, TimelineSeparator, TimelineDot, TimelineConnector, TimelineContent } from "@mui/lab"
import { displayFormattedWithTime } from "../../utils/date"

interface PortaleVenditaHistoryProps {
  history: StoricoCambioPrezzoBene[]
}

const PortaleVenditaHistory: React.FC<PortaleVenditaHistoryProps> = ({ history }) => {

  const titleFontSize = "15px"

  return (
    <>
      <Timeline style={{ transition: "all .2s", }}>
        <TimelineItem>
          <TimelineOppositeContent fontSize={titleFontSize} color="text.secondary">
            Data di Cambio Valutazione
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot variant="outlined" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent fontSize={titleFontSize}>Valutazione</TimelineContent>
        </TimelineItem>
        {history.map(he =>
          <TimelineItem key={he.id}>
            <TimelineOppositeContent color="text.secondary">
              {displayFormattedWithTime(he.data)}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>{he.valutazione} €</TimelineContent>
          </TimelineItem>
        )}
      </Timeline>
    </>
  )
}

export default PortaleVenditaHistory
